import React from 'react';
import { Route } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Spin } from 'antd';

import loginConfig from 'auth/loginConfig';

const ProtectedRoute = ({ component, ...args }: any) => {
	const params = new URLSearchParams(args.location.search);
	const redirectFromAdmin = !!params.get('admin');
	const loginOptions = redirectFromAdmin
		? { redirectFromAdmin, ...loginConfig }
		: loginConfig;
	return (
		<Route
			component={withAuthenticationRequired(component, {
				onRedirecting: () => <Spin />,
				loginOptions,
			})}
			{...args}
		/>
	);
};

export default ProtectedRoute;
